export default {"src":"/_next/static/media/pdf-icon.2755b4f2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};